const retry = require('retry');

const defaultOptions = {
  retries: 3,
  factor: 2,
  minTimeout: 500,
  maxTimeout: 2000,
  randomize: true,
}

function wrapRetry(fn, configOptions) {
  const self = this;
  if (typeof fn !== 'function' || (configOptions && typeof configOptions !== 'object')) {
    console.log('invalid args');
    throw new Error("Invalid arguments for retry. (retry(function [, options]))");
  }
  const options = Object.assign({}, defaultOptions, configOptions || {});

  const innerFunction = function(args) {
    const functionArguments = arguments;
    const operation = retry.operation(options);
    return new Promise(function(resolve, reject) {
      operation.attempt(function(currentAttempt) {
        fn.apply(self, functionArguments)
          .then(function(res) {
            resolve(res);
          })
          .catch(function(err) {
            if (operation.retry(err)) {
              return;
            }
            reject(operation.mainError());
          });
      });
    });
  };
  return innerFunction;
}

module.exports = wrapRetry;
